import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "@/i18n";

export default function NewsletterForm() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", consent: false });
  const [errors, setErrors] = useState({});

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((f) => ({ ...f, [name]: type === "checkbox" ? checked : value }));
  };

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = t("newsletter.errorRequired");
    if (!form.email.trim()) e.email = t("newsletter.errorRequired");
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = t("newsletter.errorEmail");
    if (!form.consent) e.consent = t("newsletter.errorConsent");
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    try {
      const key = "xorzeni.leads";
      const list = JSON.parse(localStorage.getItem(key) || "[]");
      list.push({ ...form, ts: new Date().toISOString() });
      localStorage.setItem(key, JSON.stringify(list));
    } catch (err) {}
    navigate("/thank_you");
  };

  return (
    <form onSubmit={onSubmit} noValidate className="space-y-5" data-testid="newsletter-form">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label htmlFor="nl-name" className="block text-xs font-mono-brand uppercase tracking-[0.2em] text-white/70 mb-2">
            {t("newsletter.nameLabel")}
          </label>
          <input
            id="nl-name"
            type="text"
            name="name"
            value={form.name}
            onChange={onChange}
            placeholder={t("newsletter.namePlaceholder")}
            className="w-full bg-white/5 border border-white/25 focus:border-[var(--brand-terracotta)] text-white placeholder-white/40 px-4 py-3 outline-none"
            data-testid="newsletter-input-name"
            aria-invalid={!!errors.name}
          />
          {errors.name && <p className="mt-2 text-xs text-[var(--brand-terracotta-2)]" data-testid="newsletter-error-name">{errors.name}</p>}
        </div>
        <div>
          <label htmlFor="nl-email" className="block text-xs font-mono-brand uppercase tracking-[0.2em] text-white/70 mb-2">
            {t("newsletter.emailLabel")}
          </label>
          <input
            id="nl-email"
            type="email"
            name="email"
            value={form.email}
            onChange={onChange}
            placeholder={t("newsletter.emailPlaceholder")}
            className="w-full bg-white/5 border border-white/25 focus:border-[var(--brand-terracotta)] text-white placeholder-white/40 px-4 py-3 outline-none"
            data-testid="newsletter-input-email"
            aria-invalid={!!errors.email}
          />
          {errors.email && <p className="mt-2 text-xs text-[var(--brand-terracotta-2)]" data-testid="newsletter-error-email">{errors.email}</p>}
        </div>
      </div>

      <label className="flex items-start gap-3 text-sm text-white/80">
        <input
          type="checkbox"
          name="consent"
          checked={form.consent}
          onChange={onChange}
          className="mt-1 accent-[var(--brand-terracotta)]"
          data-testid="newsletter-input-consent"
        />
        <span>{t("newsletter.consent")}</span>
      </label>
      {errors.consent && <p className="text-xs text-[var(--brand-terracotta-2)]" data-testid="newsletter-error-consent">{errors.consent}</p>}

      <button
        type="submit"
        className="inline-flex items-center bg-[var(--brand-terracotta)] hover:bg-[var(--brand-terracotta-2)] text-white px-6 py-3 font-medium"
        data-testid="newsletter-submit"
      >
        {t("newsletter.submit")}
      </button>
    </form>
  );
}
